import { Container, Divider, useMediaQuery } from '@material-ui/core'
import React from 'react'
import FlexView from 'react-flexview/lib'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { SessionContextStore } from '../../../context/SessionContext'
import DataLayerService from '../../../services/DataLayerService'
import {
  EventEmitterService,
  EventKey,
} from '../../../services/EventEmitterService'
import { BackButton } from '../../Core/Buttons/BackButton'
import { ContinueButton } from '../../Core/Buttons/ContinueButton'
import { CustomizeCoverages } from '../Coverages/CustomizeCoverages'
import { DatePlanSummary } from './Sections/DatePlanSummary'
import { LiabilityPlanSummary } from './Sections/LiabilityPlanSumamry'
import { VehiclePlanSummary } from './Sections/VehiclePlanSummary'
import { BottomSheetPolicySummary } from '../BottomSheetPolicySummary'
import { BrowserView, MobileView, isBrowser } from 'react-device-detect'
import { TextButton } from '../../Core/Buttons/TextButton'
var classNames = require('classnames')

export const PlanSummary = () => {
  const sessionContext = React.useContext(SessionContextStore)
  const offersContext = React.useContext(BuyingInsuranceContextStore)
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('md'))

  const [editMode, setEditMode] = React.useState(false)

  const onDateChanged = (date) => {
    offersContext.changeStartingDate(new Date(date))
  }

  const onContinue = () => {
    EventEmitterService.dispatch(EventKey.FLOW_SUMMARY_FINISH)
  }

  const goBack = () => {
    if (editMode) {
      setEditMode(!editMode)
    } else EventEmitterService.dispatch(EventKey.FLOW_GO_BACK)
  }

  const openPopup = () => {
    setEditMode(!editMode)
    if (!editMode)
      DataLayerService.pushToDataLayer({
        event: 'summary-page-clicked-edit-plan',
      })
    else
      DataLayerService.pushToDataLayer({
        event: 'summary-page-clicked-view-summary',
      })
  }

  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <Container className="margin-top-basic">
      <FlexView className="space-between full-width" vAlignContent={'center'}>
        <div className="text-title bold blue">Your plan</div>
      </FlexView>

      <Divider />

      {!editMode && (
        <>
          <DatePlanSummary
            onDateChanged={onDateChanged}
            date={offersContext.subscriptionStartTime}
          />

          <Divider />

          <LiabilityPlanSummary
            options={offersContext.options}
            offerCart={offersContext.offerCart}
          />

          <Divider />
        </>
      )}

      {isMobile && (
        <BottomSheetPolicySummary title={'Continue'} onClick={onContinue} />
      )}

      {editMode && (
        <>
          <DatePlanSummary
            onDateChanged={onDateChanged}
            date={offersContext.subscriptionStartTime}
          />
          <Divider />
          <CustomizeCoverages />
        </>
      )}
      <FlexView hAlignContent={'right'}>
        <TextButton
          onClick={openPopup}
          text={editMode ? 'View summary' : 'Edit plan'}
          withBorder
          className={'quote-button-size margin-bottom-basic margin-top-basic'}
        />
      </FlexView>

      {/* <TextButton hAlignContent={'right'} onClick={() => {
                setEditMode(!editMode)
                if(!editMode)
                    DataLayerService.pushToDataLayer({event: 'summary-page-clicked-edit-plan'})
                else
                    DataLayerService.pushToDataLayer({event: 'summary-page-clicked-view-summary'})
            }} className="quote-button-size">{editMode ? "View summary" : "Edit plan"}</TextButton>
       */}
      {!isMobile && (
        <FlexView>
          <BackButton onClick={goBack} />
          <ContinueButton onClick={onContinue} />
        </FlexView>
      )}
    </Container>
  )
}
